/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateMovesDto } from '../model';
// @ts-ignore
import type { CreateYardInternalMovesDto } from '../model';
// @ts-ignore
import type { YardInternalMoveDto } from '../model';
/**
 * YardInternalMovesApi - axios parameter creator
 */
export const YardInternalMovesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateYardInternalMovesDto} [createYardInternalMovesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardInternalMovesCreate: async (createYardInternalMovesDto?: CreateYardInternalMovesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardInternalMoves/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createYardInternalMovesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMovesDto} [createMovesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardInternalMovesCreateMove: async (createMovesDto?: CreateMovesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardInternalMoves/CreateMove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMovesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardInternalMovesApi - functional programming interface
 */
export const YardInternalMovesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardInternalMovesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateYardInternalMovesDto} [createYardInternalMovesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardInternalMovesCreate(createYardInternalMovesDto?: CreateYardInternalMovesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardInternalMoveDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardInternalMovesCreate(createYardInternalMovesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardInternalMovesApi.yardInternalMovesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateMovesDto} [createMovesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardInternalMovesCreateMove(createMovesDto?: CreateMovesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardInternalMovesCreateMove(createMovesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardInternalMovesApi.yardInternalMovesCreateMove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardInternalMovesApi - factory interface
 */
export const YardInternalMovesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardInternalMovesApiFp(configuration)
    return {
        /**
         * 
         * @param {YardInternalMovesApiYardInternalMovesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardInternalMovesCreate(requestParameters: YardInternalMovesApiYardInternalMovesCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<YardInternalMoveDto>> {
            return localVarFp.yardInternalMovesCreate(requestParameters.createYardInternalMovesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardInternalMovesApiYardInternalMovesCreateMoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardInternalMovesCreateMove(requestParameters: YardInternalMovesApiYardInternalMovesCreateMoveRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.yardInternalMovesCreateMove(requestParameters.createMovesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for yardInternalMovesCreate operation in YardInternalMovesApi.
 */
export interface YardInternalMovesApiYardInternalMovesCreateRequest {
    readonly createYardInternalMovesDto?: CreateYardInternalMovesDto
}

/**
 * Request parameters for yardInternalMovesCreateMove operation in YardInternalMovesApi.
 */
export interface YardInternalMovesApiYardInternalMovesCreateMoveRequest {
    readonly createMovesDto?: CreateMovesDto
}

/**
 * YardInternalMovesApi - object-oriented interface
 */
export class YardInternalMovesApi extends BaseAPI {
    /**
     * 
     * @param {YardInternalMovesApiYardInternalMovesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardInternalMovesCreate(requestParameters: YardInternalMovesApiYardInternalMovesCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return YardInternalMovesApiFp(this.configuration).yardInternalMovesCreate(requestParameters.createYardInternalMovesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardInternalMovesApiYardInternalMovesCreateMoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardInternalMovesCreateMove(requestParameters: YardInternalMovesApiYardInternalMovesCreateMoveRequest = {}, options?: RawAxiosRequestConfig) {
        return YardInternalMovesApiFp(this.configuration).yardInternalMovesCreateMove(requestParameters.createMovesDto, options).then((request) => request(this.axios, this.basePath));
    }
}

